"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));
var _Clear = _interopRequireDefault(require("@material-ui/icons/Clear"));
var _clsx = _interopRequireDefault(require("clsx"));
var _styles = require("@material-ui/core/styles");
var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));
var _Input = require("../Input");
var _excluded = ["defaultValue", "inputRef", "onSubmit", "onClear"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    icon: {
      position: 'relative',
      borderRadius: 5,
      width: theme.spacing(6.5),
      padding: theme.spacing(1, 0),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer'
    },
    searchInputWrapper: {
      display: 'flex',
      justifyContent: 'flex-end',
      width: 207
    },
    inputAdornment: {
      cursor: 'pointer'
    },
    clearAdornment: {
      color: theme.palette.darkGrey.light
    }
  };
});
var SearchInput = function SearchInput(props) {
  var classes = useStyles();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    inputVisible = _useState2[0],
    setInputVisible = _useState2[1];
  var defaultValue = props.defaultValue,
    inputRef = props.inputRef,
    onSubmit = props.onSubmit,
    onClear = props.onClear,
    other = _objectWithoutProperties(props, _excluded);
  var handleBlur = function handleBlur() {
    if (inputRef.current && !inputRef.current.value) setInputVisible(false);
  };
  var clearInput = function clearInput() {
    if (inputRef.current) {
      inputRef.current.value = '';
      inputRef.current.focus();
      onClear();
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, inputVisible || defaultValue ? /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.searchInputWrapper
  }, /*#__PURE__*/_react["default"].createElement(_Input.InputBase, _extends({
    autoFocus: true,
    defaultValue: defaultValue,
    inputRef: inputRef
  }, other, {
    startAdornment: /*#__PURE__*/_react["default"].createElement(_InputAdornment["default"], {
      className: classes.inputAdornment,
      onClick: function onClick() {
        var _inputRef$current;
        return onSubmit((_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.value);
      },
      position: "start"
    }, /*#__PURE__*/_react["default"].createElement(_Search["default"], {
      "aria-label": "search",
      color: "primary"
    })),
    endAdornment: /*#__PURE__*/_react["default"].createElement(_InputAdornment["default"], {
      className: (0, _clsx["default"])(classes.inputAdornment, classes.clearAdornment),
      position: "end"
    }, /*#__PURE__*/_react["default"].createElement(_Clear["default"], {
      "aria-label": "clear",
      onClick: clearInput
    })),
    autoComplete: "off",
    onBlur: handleBlur,
    onKeyUp: function onKeyUp(_ref) {
      var key = _ref.key;
      if (key === 'Enter') onSubmit(inputRef.current && inputRef.current.value);
    }
  }))) : /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    "aria-label": "show-search-input",
    color: "primary",
    onClick: function onClick() {
      return setInputVisible(true);
    },
    className: classes.icon
  }, /*#__PURE__*/_react["default"].createElement(_Search["default"], null)));
};
SearchInput.propTypes = {
  defaultValue: _propTypes["default"].string,
  inputRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].shape({
    current: _propTypes["default"].instanceOf(Element)
  })]),
  onSubmit: _propTypes["default"].func.isRequired,
  onClear: _propTypes["default"].func.isRequired
};
SearchInput.defaultProps = {
  inputRef: undefined,
  defaultValue: undefined
};
var _default = exports["default"] = SearchInput;